import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { Icon } from 'zarm';
import Render from '@/components/Render';
import Modal from '@/components/Modal';
import { findModuleFromPage } from '@/utils/utils';

const renderBy = status => node => {
  return status ? node : null;
};

const toolbarStyleHTML = {
  __html: `
    .components-toolbar-render {
      z-index: 11 !important;
    }
  `
};
const moduleStyleHTML = {
  __html: `
    .components-modal-render.module-bottom {
      bottom: 61px !important;
      position: fixed;
    }
  `
};
export const render = (config = {}, getClick) => {
  const {
    attrs = {}
  } = config;
  const {
    type,
    position,
    title,
    button = [],
    dataSource = []
  } = attrs;
  const hadToolbar = findModuleFromPage((curr = {}) => {
    return curr && curr.component === 'healthToolbarModule';
  });
  const showButton = (type === 1 || type === 2 || type === 4) && position !== 'bottom';
  const showTitle = (type === 1 || type === 2 || type === 4) && position !== 'bottom';
  const className = position ? `module-${position}` : '';
  const primary = type === 1;
  const headerNode = renderBy(showTitle && title)( /*#__PURE__*/React.createElement("div", {
    className: "module-header"
  }, title));
  const bodyNode = /*#__PURE__*/React.createElement("div", {
    className: "module-body"
  }, /*#__PURE__*/React.createElement(Render, {
    components: dataSource
  }));
  const closeNode = /*#__PURE__*/React.createElement("div", {
    className: "module-close",
    onClick: Modal.hide
  }, /*#__PURE__*/React.createElement(Icon, {
    className: "icon",
    type: "wrong"
  }));
  const toolbarStyleNode = renderBy(position === 'bottom')( /*#__PURE__*/React.createElement("style", {
    dangerouslySetInnerHTML: toolbarStyleHTML
  }));
  const moduleStyleNode = renderBy(hadToolbar)( /*#__PURE__*/React.createElement("style", {
    dangerouslySetInnerHTML: moduleStyleHTML
  }));
  const children = /*#__PURE__*/React.createElement(React.Fragment, null, toolbarStyleNode, moduleStyleNode, /*#__PURE__*/React.createElement("div", {
    className: "modal-module"
  }, headerNode, bodyNode, closeNode));
  const operations = button.map((item = {}, index) => {
    const {
      text,
      events = {}
    } = item;
    const onClick = getClick(_objectSpread(_objectSpread({}, events), {}, {
      index
    }));
    let itemType;
    let shadow = false;

    if (primary) {
      itemType = 'primary';
    } else {
      itemType = index === 1 ? 'primary' : 'default';
      shadow = index === 1;
    }

    return {
      shadow,
      onClick,
      type: itemType,
      children: text
    };
  });
  Modal.show({
    children,
    className,
    operations: showButton ? operations : []
  });
};
export default render;